













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ProgressBar extends Vue {
	@Prop({ type: [Number, String], default: 30 }) height!: number;
	@Prop({ type: Number, default: 0 }) percentage!: number;
	@Prop({ type: String, default: '' }) name!: string;
	@Prop({ type: Boolean, default: false }) invert!: boolean;

	get BarColor(): string {
	    const pct = this.percentage;
	    const invert = this.invert;

	    if (pct < 25) return !invert ? '#f63a0f' : '#86e01e';
	    if (pct < 50) return !invert ? '#f27011' : '#f2d31b';
	    if (pct < 75) return '#f2b01e';
	    if (pct < 100) return !invert ? '#f2d31b' : '#f27011';
	    return !invert ? '#86e01e' : '#f63a0f';
	}
}
